import { VendorProduct } from './vendor-product';

export class Vendor {
  id: number;
  description: string;
  name: string;
  products: Array<VendorProduct>;
}
